export const HTML_DEFAULTS = {
    html: '<!-- Paste any HTML here -->\n<div style="padding:20px;border:1px dashed #ccc;border-radius:8px;color:#666;text-align:center">Custom HTML block</div>',
};
/**
 * Raw HTML embed widget. Content is passed through verbatim — this
 * widget is explicitly opt-in for cases where a user needs to paste
 * iframe embeds, custom scripts, analytics snippets, etc.
 *
 * SECURITY NOTE: because the content is unescaped, consumers should
 * only expose this widget to trusted authors (site owners). End-user
 * untrusted content MUST NOT flow into this widget.
 */
export const htmlWidget = {
    type: "html",
    defaultProps: HTML_DEFAULTS,
    renderHtml(props) {
        return `<div class="emk-html">${props.html}</div>`;
    },
};
//# sourceMappingURL=html.js.map